import { Lesson } from '@/models/Lesson'

class LessonRecord {
  constructor(
    id,
    lesson,
    date,
    createdAt,
    updatedAt,
  ) {
    if (!(typeof id === 'string')) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    if (!(lesson instanceof Lesson)) {
      throw new TypeError(`'lesson' must be an instance of [object Lesson]. Actual: ${typeof Lesson}`)
    }
    this.id = id
    this.lesson = lesson
    this.date = date
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }

  toObject() {
    return {
      id: this.id,
      data: {
        lesson: this.lesson.toObject(),
        date: this.date,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      }
    }
  }

  dateString() {
    const m = this.date.getMonth() + 1
    const d = this.date.getDate()
    return m + "月" + d + "日"
  }

  hasId(id) {
    if (!(typeof id === "string")) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    return (this.id === id)
  }
}

class LessonRecords {
  constructor(records) {
    if (!(records instanceof Array)) {
      throw new TypeError(`'records' must be an instance of [object Array]. Actual: ${typeof records}`)
    }
    this.records = records
  }

  get() {
    return this.records
  }

  find(id) {
    if (!(typeof id === "string")) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    return this.records[this.records.findIndex(r =>  r.hasId(id))]
  }

  length() {
    return this.records.length
  }

  toObjects() {
    return this.records.map(record => {
      return record.toObject()
    })
  }

  update (record) {
    if (!(record instanceof LessonRecord)) {
      throw new TypeError(`'record' must be an instance of [object LessonRecord]. Actual: ${typeof record}`)
    }
    this.records.splice(this.records.findIndex(r => r.hasId(record.id)), 1, record)
    return this
  }

  remove (recordId) {
    if (!(typeof recordId === "string")) {
      throw new TypeError(`The type of 'record' must be String. Actual: ${typeof recordId}`)
    }
    this.records.splice(this.records.findIndex(r => r.hasId(recordId)), 1)
    return this
  }

  sortByDate() {
    this.records.sort(function(a, b) {
      if (a.date < b.date) {
        return -1
      }
      if (a.date > b.date) {
        return 1
      }
      return 0
    })
    return this
  }

  getPaymentAmount() {
    var amount = 0
    this.records.forEach(record => {
      amount += record.lesson.wage
    })
    return amount
  }

  filterByStudentId(studentId) {
    if (!(typeof studentId === 'string')) {
      throw new TypeError(`The type of 'studentId' must be String. Actual: ${typeof studentId}`)
    }
    const studentIds = this.records.filter(record => record.lesson.studentId === studentId)
    const arr = Array.from(new Set(studentIds))
    return new LessonRecords(arr)    
  }

  getLessonStudentIds() {
    var studentIds = this.records.map(record => record.lesson.studentId)
    var ids = new Set(studentIds) 
    return Array.from(ids)
  }


}

export { LessonRecord, LessonRecords }